import React from "react"
import {DialogTitle, Stack} from "@mui/material"
import MerkmalToWidgetList from "../general/MerkmalToWidgetList"

const DialogMilestoneContent = ({value}) => {
    const merkmalList = value.connections?.map(entry => entry.origin)
    return (
        <>
            <DialogTitle>Ereignis: {value?.longname}</DialogTitle>
            <Stack spacing={2}>
                <MerkmalToWidgetList
                    merkmalList={merkmalList}
                    rootPointer={`/${value.id}`}
                />
            </Stack>
        </>
    )
}

export default DialogMilestoneContent
